(function (window, $) {
	'use strict';
	if (!$) {
		return;
	}
	$(function () {
		$('.js-linkinbio').each(function () {
			var section = this;
			var $section = $(section);
			if ($section.data('linkinbioReady')) {
				return;
			}
			$section.data('linkinbioReady', true);
			var openers = new WeakMap();
			var copyResetTimers = new WeakMap();
			var shareCarousels = new WeakMap();
			var descriptionTransitions = new WeakMap();
			var observedWidths = new WeakMap();
			var dialogs = Array.from(section.querySelectorAll('.js-linkinbio-popup'));
			function prepareShareCarousel(dialog) {
				if (!dialog || !dialog.open) {
					return;
				}
				refreshDescriptionToggle(dialog);
				var row = dialog.querySelector('.js-linkinbio-share-actions');
				if (!row) {
					return;
				}
				var wrapper = row.parentElement;
				var buttons = Array.from(row.querySelectorAll('.js-linkinbio-share'));
				var totalWidth = buttons.reduce(function (width, button) {
					var style = window.getComputedStyle(button);
					return (
						width +
						button.getBoundingClientRect().width +
						parseFloat(style.marginLeft || 0) +
						parseFloat(style.marginRight || 0)
					);
				}, 0);
				var carousel = shareCarousels.get(row);
				if (totalWidth <= wrapper.clientWidth + 1) {
					if (carousel) {
						carousel.destroy();
						shareCarousels.delete(row);
					}
					return;
				}
				if (carousel) {
					carousel.resize();
					return;
				}
				var options = {
					cellSelector: '.js-linkinbio-share',
					cellAlign: 'center',
					contain: true,
					groupCells: true,
					wrapAround: false,
					autoPlay: false,
					pageDots: false,
					prevNextButtons: true,
					draggable: true,
					accessibility: true,
				};
				if (typeof window.Flickity === 'function') {
					carousel = new window.Flickity(row, options);
				} else if ($.fn.flickity) {
					$(row).flickity(options);
					carousel = $(row).data('flickity');
				}
				if (carousel) {
					shareCarousels.set(row, carousel);
				}
			}
			// Re-evaluate overflow on viewport changes, font loading and popup reopening.
			if (window.ResizeObserver) {
				var shareObserver = new window.ResizeObserver(function (entries) {
					entries.forEach(function (entry) {
						var width = entry.contentRect.width;
						if (observedWidths.get(entry.target) === width) {
							return;
						}
						observedWidths.set(entry.target, width);
						prepareShareCarousel(entry.target.closest('dialog'));
					});
				});
				section.querySelectorAll('.js-linkinbio-share-carousel').forEach(function (wrapper) {
					shareObserver.observe(wrapper);
				});
			} else {
				$(window).on('resize', function () {
					dialogs.forEach(prepareShareCarousel);
				});
			}
			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(function () {
					dialogs.forEach(prepareShareCarousel);
				});
			}
			function httpUrl(value) {
				try {
					var url = new URL(value);
					return /^https?:$/.test(url.protocol) ? url.href : '';
				} catch (error) {
					return '';
				}
			}
			function status(dialog, message, screenReaderOnly) {
				$(dialog)
					.find('.js-linkinbio-status')
					.toggleClass('section-flexi-linkinbio__status--sr-only', Boolean(message && screenReaderOnly))
					.text(message);
			}
			async function writeClipboard(url) {
				try {
					if (!window.navigator.clipboard || !window.isSecureContext) {
						throw new Error('Clipboard unavailable');
					}
					await window.navigator.clipboard.writeText(url);
					return true;
				} catch (error) {
					return false;
				}
			}
			function showCopyFeedback(button, dialog, didCopy) {
				var label = button.querySelector('.js-linkinbio-share-label');
				var copyIcon = button.querySelector('.js-linkinbio-copy-icon');
				var copiedIcon = button.querySelector('.js-linkinbio-copied-icon');
				if (!label) {
					return;
				}
				var existingTimer = copyResetTimers.get(button);
				var feedbackMessage = didCopy ? 'Link copied.' : 'Copy failed.';
				if (existingTimer) {
					window.clearTimeout(existingTimer);
				}
				label.textContent = didCopy ? 'Copied' : 'Copy failed';
				if (copyIcon && copiedIcon) {
					copyIcon.hidden = didCopy;
					copiedIcon.hidden = !didCopy;
				}
				status(dialog, feedbackMessage, true);
				copyResetTimers.set(
					button,
					window.setTimeout(function () {
						label.textContent = button.dataset.defaultLabel || 'Copy Link';
						if (copyIcon && copiedIcon) {
							copyIcon.hidden = false;
							copiedIcon.hidden = true;
						}
						if ($(dialog).find('.js-linkinbio-status').text() === feedbackMessage) {
							status(dialog, '');
						}
						copyResetTimers.delete(button);
					}, 3000)
				);
			}
			function refreshDescriptionToggle(dialog) {
				var toggle = dialog.querySelector('.js-linkinbio-description-toggle');
				var description = dialog.querySelector('.js-linkinbio-description');
				if (
					!toggle ||
					!description ||
					toggle.linkinbioAnimating ||
					toggle.getAttribute('aria-expanded') === 'true'
				) {
					return;
				}
				toggle.hidden = description.scrollHeight <= description.clientHeight + 1;
			}
			function prepareDescription(dialog) {
				var toggle = dialog.querySelector('.js-linkinbio-description-toggle');
				var description = dialog.querySelector('.js-linkinbio-description');
				var shell = dialog.querySelector('.js-linkinbio-description-shell');
				if (!toggle || !description || !shell) {
					return;
				}
				cancelDescriptionTransition(shell);
				toggle.linkinbioAnimating = false;
				shell.style.height = 'auto';
				description.classList.remove('section-flexi-linkinbio__popup-description--expanded');
				toggle.setAttribute('aria-expanded', 'false');
				toggle.textContent = toggle.dataset.collapsedLabel || 'Read More';
				refreshDescriptionToggle(dialog);
			}
			function cancelDescriptionTransition(shell) {
				var cancel = descriptionTransitions.get(shell);
				if (cancel) {
					cancel();
				}
			}
			function afterDescriptionTransition(shell, callback) {
				cancelDescriptionTransition(shell);
				var finished = false;
				var style = window.getComputedStyle(shell);
				function milliseconds(value) {
					return (parseFloat(value) || 0) * (value.trim().endsWith('ms') ? 1 : 1000);
				}
				var delays = style.transitionDelay.split(',').map(milliseconds);
				var duration = Math.max.apply(
					null,
					style.transitionDuration.split(',').map(function (value, index) {
						return milliseconds(value) + delays[index % delays.length];
					})
				);
				var timer;
				function cleanup() {
					finished = true;
					window.clearTimeout(timer);
					shell.removeEventListener('transitionend', finish);
					descriptionTransitions.delete(shell);
				}
				function finish(event) {
					if (finished || (event && (event.target !== shell || event.propertyName !== 'height'))) {
						return;
					}
					cleanup();
					callback();
				}
				descriptionTransitions.set(shell, cleanup);
				shell.addEventListener('transitionend', finish);
				timer = window.setTimeout(finish, duration ? duration + 80 : 0);
			}
			dialogs.forEach(function (dialog) {
				if (typeof dialog.showModal !== 'function') {
					return;
				}
				$section
					.find('.js-linkinbio-open')
					.filter(function () {
						return this.getAttribute('aria-controls') === dialog.id;
					})
					.prop('hidden', false);
				dialog.addEventListener('close', function () {
					cancelDescriptionTransition(dialog.querySelector('.js-linkinbio-description-shell'));
					var opener = openers.get(dialog);
					if (opener && opener.isConnected) {
						opener.focus();
					}
				});
				// Backdrop clicks have the dialog as their target but lie outside its box.
				dialog.addEventListener('click', function (event) {
					if (event.target !== dialog) {
						return;
					}
					var rect = dialog.getBoundingClientRect();
					if (
						event.clientX < rect.left ||
						event.clientX > rect.right ||
						event.clientY < rect.top ||
						event.clientY > rect.bottom
					) {
						dialog.close();
					}
				});
			});
			$section
				.on('click.linkinbio', '.js-linkinbio-open', function (event) {
					event.preventDefault();
					event.stopPropagation();
					var id = this.getAttribute('aria-controls');
					var dialog = dialogs.find(function (item) {
						return item.id === id;
					});
					if (!dialog || dialog.open || typeof dialog.showModal !== 'function') {
						return;
					}
					openers.set(dialog, this);
					status(dialog, '');
					dialog.showModal();
					prepareDescription(dialog);
					prepareShareCarousel(dialog);
				})
				.on('click.linkinbio', '.js-linkinbio-close', function () {
					this.closest('dialog').close();
				})
				.on('focusin.linkinbio', '.js-linkinbio-share', function () {
					var row = this.closest('.js-linkinbio-share-actions');
					var carousel = shareCarousels.get(row);
					if (carousel) {
						carousel.selectCell(this, false, true);
					}
				})
				.on('click.linkinbio', '.js-linkinbio-description-toggle', function () {
					var dialog = this.closest('dialog');
					var description = dialog ? dialog.querySelector('.js-linkinbio-description') : null;
					var shell = dialog ? dialog.querySelector('.js-linkinbio-description-shell') : null;
					if (!description || !shell || this.linkinbioAnimating) {
						return;
					}
					var toggle = this;
					var willExpand = this.getAttribute('aria-expanded') !== 'true';
					var currentHeight = shell.getBoundingClientRect().height;
					// Measure at the current width, including changes made while expanded.
					var collapsedHeight = currentHeight;
					if (!willExpand) {
						description.classList.remove('section-flexi-linkinbio__popup-description--expanded');
						collapsedHeight = shell.getBoundingClientRect().height;
						description.classList.add('section-flexi-linkinbio__popup-description--expanded');
					}
					this.linkinbioAnimating = true;
					this.setAttribute('aria-expanded', String(willExpand));
					this.textContent = willExpand
						? this.dataset.expandedLabel || 'Read Less'
						: this.dataset.collapsedLabel || 'Read More';
					shell.style.height = currentHeight + 'px';
					if (willExpand) {
						description.classList.add('section-flexi-linkinbio__popup-description--expanded');
						var expandedHeight = shell.scrollHeight;
						shell.getBoundingClientRect();
						shell.style.height = expandedHeight + 'px';
						afterDescriptionTransition(shell, function () {
							shell.style.height = 'auto';
							toggle.linkinbioAnimating = false;
						});
					} else {
						shell.getBoundingClientRect();
						shell.style.height = collapsedHeight + 'px';
						afterDescriptionTransition(shell, function () {
							description.classList.remove('section-flexi-linkinbio__popup-description--expanded');
							shell.style.height = 'auto';
							toggle.linkinbioAnimating = false;
						});
					}
				})
				.on('click.linkinbio', '.js-linkinbio-share', async function () {
					var button = this;
					var dialog = button.closest('dialog');
					if (!dialog) {
						return;
					}
					var url = httpUrl(dialog.dataset.shareUrl);
					if (!url || button.disabled) {
						return;
					}
					var title = dialog.dataset.shareTitle || '';
					var description = dialog.dataset.shareDescription || '';
					var platform = button.dataset.platform;
					var destination = '';
					var encodedUrl = encodeURIComponent(url);
					status(dialog, '');
					if (platform === 'copy_link' || platform === 'instagram') {
						button.disabled = true;
						try {
							if (platform === 'instagram') {
								var copying = writeClipboard(url);
								// Reserve a tab during the click so the async clipboard operation does not trigger popup blocking.
								var instagramTab = window.open('about:blank', '_blank');
								if (instagramTab) {
									instagramTab.opener = null;
								}
								var copied = await copying;
								if (copied && instagramTab && !instagramTab.closed) {
									status(dialog, 'Link copied—paste it into an Instagram message or Story link sticker.');
									instagramTab.location.replace('https://www.instagram.com/');
								} else {
									if (instagramTab && !instagramTab.closed) {
										instagramTab.close();
									}
									status(dialog, copied ? 'Link copied. ' : 'Copy this link: ' + url + ' ');
									$('<a>', {
										href: 'https://www.instagram.com/',
										target: '_blank',
										rel: 'noopener noreferrer',
										text: 'Open Instagram',
									}).appendTo($(dialog).find('.js-linkinbio-status').append(' '));
								}
							} else {
								showCopyFeedback(button, dialog, await writeClipboard(url));
							}
						} finally {
							button.disabled = false;
						}
						return;
					}
					if (platform === 'email') {
						window.location.href =
							'mailto:?subject=' +
							encodeURIComponent(title) +
							'&body=' +
							encodeURIComponent([description, url].filter(Boolean).join('\n\n'));
						return;
					}
					if (platform === 'facebook') {
						destination = 'https://www.facebook.com/sharer.php?u=' + encodedUrl;
					}
					if (platform === 'linkedin') {
						destination = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl;
					}
					if (platform === 'twitter') {
						destination =
							'https://x.com/intent/tweet?url=' + encodedUrl + '&text=' + encodeURIComponent(title);
					}
					if (platform === 'whatsapp') {
						destination =
							'https://wa.me/?text=' + encodeURIComponent([title, url].filter(Boolean).join('\n\n'));
					}
					if (platform === 'pinterest') {
						var media = httpUrl(dialog.dataset.shareImage);
						if (!media) {
							status(dialog, 'An image is needed to share this link on Pinterest.');
							return;
						}
						destination =
							'https://www.pinterest.com/pin/create/button/?url=' +
							encodedUrl +
							'&media=' +
							encodeURIComponent(media) +
							'&description=' +
							encodeURIComponent(description || title);
					}
					if (platform === 'custom') {
						var values = { url: url, title: title, description: description };
						destination = (button.dataset.customUrl || '').replace(
							/\{(url|title|description)\}/g,
							function (match, key) {
								return encodeURIComponent(values[key]);
							}
						);
					}
					destination = httpUrl(destination);
					if (!destination) {
						status(dialog, 'This share action has no valid destination.');
						return;
					}
					window.open(destination, '_blank', 'noopener,noreferrer');
				});
		});
	});
})(window, window.jQuery);
